import initialState from './CampaignInitialState';
import reducers from './CampaignReducer';

export default {
  initialState,
  reducers,
};
